module.exports = __webpack_public_path__ + "assets/img/mo-guest-page-layer-13-58792d2b.png";